module.exports = __webpack_public_path__ + "static/media/trophy.2339d820.png";